"use client";

import { motion, useReducedMotion } from "framer-motion";
import { BadgeCheck, Receipt, ShieldCheck, Clock } from "lucide-react";
export default function Trust() {
  const reduce = useReducedMotion();
  const pillars = [{
    icon: BadgeCheck,
    title: "Técnicos certificados",
    body: "Profesionales cualificados para cada tipo de intervención."
  }, {
    icon: Receipt,
    title: "Presupuesto cerrado sin sorpresas",
    body: "Sabe el precio antes de que empecemos."
  }, {
    icon: ShieldCheck,
    title: "Garantía por escrito",
    body: "Todos nuestros trabajos quedan garantizados."
  }, {
    icon: Clock,
    title: "Respuesta rápida y urgencias 24 horas",
    body: "Atendemos averías urgentes cualquier día del año."
  }];
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: reduce ? 0 : 0.08,
        delayChildren: 0.05
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: reduce ? 0 : 16
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: reduce ? 0.2 : 0.5,
        ease: [0.2, 0.6, 0.2, 1]
      }
    }
  };
  return <section data-section-id="32631" id="por-qué-confiar-en-nosotros" data-nav="light" className="relative overflow-hidden bg-background text-foreground" style={{
    paddingTop: "clamp(4rem, 7vw, 7rem)",
    paddingBottom: "clamp(4rem, 7vw, 7rem)"
  }}>
      <div className="relative mx-auto max-w-[1360px]" style={{
      paddingLeft: "clamp(1.25rem, 4vw, 3rem)",
      paddingRight: "clamp(1.25rem, 4vw, 3rem)"
    }}>
        <motion.div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }}>
          <motion.div variants={item} className="flex items-center justify-center gap-3">
            <span aria-hidden="true" className="inline-block h-3 w-[1.5px]" style={{
            backgroundColor: "var(--rust)"
          }} />
            <span className="font-sans font-semibold uppercase" style={{
            color: "var(--rust)",
            fontSize: "0.8125rem",
            letterSpacing: "0.22em",
            lineHeight: 1
          }}>
              GARANTÍA DE SERVICIO
            </span>
            <span aria-hidden="true" className="inline-block h-3 w-[1.5px]" style={{
            backgroundColor: "var(--rust)"
          }} />
          </motion.div>

          <motion.h2 variants={item} className="font-serif font-bold uppercase" style={{
          fontSize: "clamp(2rem, 4.5vw, 3.5rem)",
          letterSpacing: "-0.005em",
          lineHeight: 1.05,
          marginTop: "clamp(0.75rem, 1.2vw, 1.25rem)",
          color: "var(--primary)"
        }}>
            Por qué confiar en Servicios de reparaciones
          </motion.h2>
        </motion.div>

        <motion.div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8" variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }}>
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <motion.div key={pillar.title} data-index={i} variants={item} className="flex flex-col p-5 sm:p-6 rounded-2xl border bg-card transition-shadow duration-300 hover:shadow-md" style={{
            backgroundColor: "var(--paper-sunk)",
            borderColor: "var(--rule)"
          }}>
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center mb-5 shrink-0" style={{
              backgroundColor: "hsl(18 78% 48% / 0.1)",
              color: "var(--rust)"
            }}>
                  <Icon className="w-6 h-6 sm:w-7 sm:h-7" strokeWidth={1.75} aria-hidden="true" />
                </div>
                <h3 className="font-serif font-bold mb-2" style={{
              color: "var(--primary)",
              fontSize: "clamp(1.0625rem, 1.3vw, 1.25rem)",
              lineHeight: 1.2
            }}>
                  {pillar.title}
                </h3>
                <p className="font-default text-muted-foreground" style={{
              fontSize: "0.9375rem",
              lineHeight: 1.5
            }}>
                  {pillar.body}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}